import { z as e } from "zod";
const i = e.enum(["asc", "desc"]), a = e.object({
  sortBy: e.string(),
  sortDirection: i.optional().default("asc")
}), c = e.object({
  page: e.coerce.number().int().positive().default(1),
  pageSize: e.coerce.number().int().min(1).default(50)
}), n = e.object({
  page: e.int().positive(),
  pageSize: e.int().positive(),
  total: e.int().nonnegative()
}), s = (t) => n.extend({ items: e.array(t).readonly() }).readonly();
export {
  i as ApiSortModeSchema,
  n as PaginatedResponseMixinSchema,
  c as PaginationSchema,
  a as SortingSchema,
  s as paginatedList
};
//# sourceMappingURL=pagination.js.map
